export enum DocumentUploadSection {

    Kyc = 0,
    FullDocumentUpload = 1,
}
